import script from "./issueFormEdit.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./issueFormEdit.component.vue?vue&type=script&lang=ts&setup=true"

import "./issueFormEdit.component.vue?vue&type=style&index=0&id=212c0ac8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212c0ac8"]])

export default __exports__